/**
 * PDP product.set: keep the flavor heading in sync with the flavor picker label.
 * This runs on load and after Section Rendering swaps (flavor changes).
 */
(function () {
  const TARGET_SELECTOR = ".product__text.product-text-text_flavor_label_heading p";
  const SOURCE_SELECTOR = "flavor-picker .flavor-picker__selected-value";

  function syncFlavorLabel(root) {
    const source = root.querySelector?.(SOURCE_SELECTOR) || document.querySelector(SOURCE_SELECTOR);
    const label = source?.textContent?.trim();
    if (!label) return;

    (root.querySelectorAll?.(TARGET_SELECTOR) || document.querySelectorAll(TARGET_SELECTOR)).forEach((el) => {
      if (el.textContent?.trim() !== label) el.textContent = label;
    });
  }

  function run() {
    syncFlavorLabel(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", run);

  const main = document.querySelector("main");
  if (!main) return;

  let t;
  const mo = new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(run, 50);
  });
  mo.observe(main, { childList: true, subtree: true });
})();
